import { Injectable } from '@angular/core';
import tinycolor from 'tinycolor2';

@Injectable({
  providedIn: 'root',
})
export class ColorSpectrumService {
  constructor() {}

  // TODO: Maybe ask for a list based on the number of tiers.
  public getColors(baseColor = '#077DC5'): string[] {
    const colors: string[] = [];

    colors.push(this.lighten(baseColor, 50));
    colors.push(this.lighten(baseColor, 25));
    colors.push(baseColor);
    colors.push(this.darken(baseColor, 25));
    colors.push(this.darken(baseColor, 50));
    colors.push(this.darken(baseColor, 75));

    return colors;
  }

  private lighten(color: string, amount: number): string {
    const tinyColor = new tinycolor(color);
    return tinyColor.lighten(amount).toHexString();
  }

  private darken(color: string, amount: number): string {
    const tinyColor = new tinycolor(color);
    return tinyColor.darken(amount).toHexString();
  }
}
